import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Defer the ambient cloud background until the browser is idle so it never
// competes with the login → dashboard render path. One-time idle work; after
// the class is on body, the cloud is GPU-only forever.
(function enableAmbientCloudsWhenIdle() {
  const turnOn = () => document.body.classList.add("cloud-ready");
  if (document.readyState === "complete") {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(turnOn, { timeout: 4000 });
    } else {
      setTimeout(turnOn, 1500);
    }
  } else {
    window.addEventListener("load", () => {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(turnOn, { timeout: 4000 });
      } else {
        setTimeout(turnOn, 1500);
      }
    }, { once: true });
  }
})();
